<template>
  <Modal v-if="showModalEditWorkingHours" @close="closeModalHours">
    <div class="editWorkingHours">
      <div class="editWorkingHours__header">
        <span class="title">{{ $t('editWorkingHours') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="closeModalHours"
        />
      </div>
      <div class="editWorkingHours__body">
        <FormKit
          id="editWorkingHours-form"
          v-model="formData"
          type="form"
          :actions="false"
          @submit="saveWorkingHours"
        >
          <TableHours :data="pharmacyWorkingHours" :columns="columns" />
          <span v-if="chooseWorkingHours" class="wrongTime">
            {{ $t('chooseWorkingHours') }}
          </span>
        </FormKit>
      </div>
      <div class="editWorkingHours__buttons">
        <Button variant="filled" :title="$t('ok')" @click="submitHandler" />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="closeModalHours"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import { columns } from './configs';

@Options({
  name: 'EditWorkingHours',
  props: ['showModalEditWorkingHours', 'pharmacyWorkingHours'],
  data() {
    return {
      formData: {},
      chooseWorkingHours: false,
      columns: columns(this.$t)
    };
  },
  methods: {
    submitHandler() {
      this.$formkit.submit('editWorkingHours-form');
    },
    async saveWorkingHours() {
      const payload = { ...this.pharmacyWorkingHours };

      const wrongTime = Object.keys(payload).filter(
        (day) => payload[day].closed === false && payload[day].from === ''
      );

      if (wrongTime.length) {
        return (this.chooseWorkingHours = true);
      } else {
        this.chooseWorkingHours = false;
        this.$emit('closeModal');
      }
    },
    closeModalHours() {
      this.chooseWorkingHours = false;
      this.$emit('closeModalOld');
    }
  }
})
export default class EditWorkingHours extends Vue {}
</script>

<style lang="scss">
.editWorkingHours {
  width: 700px;
  height: 100%;
  padding: 24px;
  .editWorkingHours__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .editWorkingHours__body {
    position: relative;
    margin-bottom: 24px;
    .wrongTime {
      margin-top: 3px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $red;
    }
  }
}
</style>
